// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-notifyjs/themes/default.scss
// module id = Sczw
// module chunks = 1